(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-carousel-pets"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initBundleCarousel(section) {
    const tabs = section.querySelectorAll('.bundle-carousel__tab');
    const track = section.querySelector('.bundle-carousel__track');
    const prevBtn = section.querySelector('.bundle-carousel__arrow--prev');
    const nextBtn = section.querySelector('.bundle-carousel__arrow--next');
    const viewport = section.querySelector('.bundle-carousel__viewport');

    if (!track) return;

    let currentIndex = 0;
    let activeTab = 'dog';

    function getVisibleItems() {
      return Array.from(track.querySelectorAll('.bundle-carousel__item[data-pet="' + activeTab + '"]'));
    }

    function getVisibleCount() {
      const vw = viewport.offsetWidth;
      if (vw < 480) return 1;
      if (vw < 768) return 2;
      if (vw < 1024) return 3;
      return 4;
    }

    function getItemWidth() {
      const item = getVisibleItems()[0];
      if (!item) return 0;
      return item.offsetWidth + 16;
    }

    function updateArrows() {
      const items = getVisibleItems();
      const visible = getVisibleCount();
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= items.length - visible;
    }

    function goTo(index) {
      const items = getVisibleItems();
      const visible = getVisibleCount();
      const max = Math.max(0, items.length - visible);

      currentIndex = Math.min(Math.max(index, 0), max);

      const targetItem = items[currentIndex];
      if (!targetItem) return;

      track.style.transform = `translateX(-${targetItem.offsetLeft}px)`;

      updateArrows();
    }

    function switchTab(tab) {
      activeTab = tab;
      currentIndex = 0;

      // Show/hide items
      track.querySelectorAll('.bundle-carousel__item').forEach(item => {
        item.style.display = item.dataset.pet === activeTab ? '' : 'none';
      });

      

      updateArrows();
      goTo(0);
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('bundle-carousel__tab--active'));
        tab.classList.add('bundle-carousel__tab--active');
        switchTab(tab.dataset.tab);
      });
    });

    prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
    nextBtn.addEventListener('click', () => goTo(currentIndex + 1));
    window.addEventListener('resize', () => goTo(currentIndex));

    updateArrows();

    
  }

  document.querySelectorAll('.bundle-carousel-section').forEach(initBundleCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-bundles"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel-pets"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCarousel(section) {
    // Tab switching
    const tabs = section.querySelectorAll('.pet-carousel__tab');
    const panels = section.querySelectorAll('.pet-carousel__panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        tabs.forEach(t => t.classList.remove('pet-carousel__tab--active'));
        panels.forEach(p => p.classList.remove('pet-carousel__panel--active'));
        tab.classList.add('pet-carousel__tab--active');
        section.querySelector(`[data-panel="${target}"]`).classList.add('pet-carousel__panel--active');

        requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
        });
      });
    });

    // Carousel logic per panel
    panels.forEach(panel => {
      const track = panel.querySelector('.pet-carousel__track');
      const prevBtn = panel.querySelector('.pet-carousel__arrow--prev');
      const nextBtn = panel.querySelector('.pet-carousel__arrow--next');
      const viewport = panel.querySelector('.pet-carousel__viewport');

      if (!track) return;

      let currentIndex = 0;

      function getVisibleCount() {
        const vw = viewport.offsetWidth;
        if (vw < 480) return 1;
        if (vw < 768) return 2;
        if (vw < 1024) return 3;
        return 4;
      }

      function getItems() {
        return track.querySelectorAll('.pet-carousel__item');
      }

      function getItemWidth() {
        const item = getItems()[0];
        if (!item) return 0;
        return item.offsetWidth + 16;
      }

      function updateArrows() {
        const items = getItems();
        const visible = getVisibleCount();
        const totalItems = items.length;

        // Dacă toate produsele încap, ascunde complet săgețile
        if (totalItems <= visible) {
          prevBtn.style.visibility = 'hidden';
          nextBtn.style.visibility = 'hidden';
          // Centrează track-ul
          track.style.justifyContent = 'center';
          return;
        }

        prevBtn.style.visibility = '';
        nextBtn.style.visibility = '';
        track.style.justifyContent = '';

        prevBtn.disabled = currentIndex <= 0;
        nextBtn.disabled = currentIndex >= totalItems - visible;
      }

      function goTo(index) {
        const items = getItems();
        const visible = getVisibleCount();
        const max = Math.max(0, items.length - visible);
        currentIndex = Math.min(Math.max(index, 0), max);
        track.style.transform = `translateX(-${currentIndex * getItemWidth()}px)`;
        updateArrows();
      }

      prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
      nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

      window.addEventListener('resize', () => goTo(currentIndex));
      updateArrows();

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;
      const SWIPE_THRESHOLD = 50;

      viewport.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      viewport.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > SWIPE_THRESHOLD) {
          if (diff > 0) {
            goTo(currentIndex + 1); // swipe left → next
          } else {
            goTo(currentIndex - 1); // swipe right → prev
          }
        }
      }, { passive: true });
    });
  }

  document.querySelectorAll('.pet-carousel-section').forEach(initCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
